import React, { useState } from 'react';
import { MonitorUp, X } from 'lucide-react';

export const SmallDeviceBookstoreNotice = () => {
  const [visible, setVisible] = useState(() => new URLSearchParams(window.location.search).get('writer_device') === 'small');
  if (!visible) return null;
  return (
    <aside className="fixed inset-x-3 top-3 z-[100] mx-auto flex max-w-xl items-start gap-3 rounded-md border border-[#d4b56a] bg-[#fff9e9] p-3 text-[#352b1f] shadow-xl" data-testid="small-device-bookstore-banner">
      <MonitorUp className="mt-0.5 h-5 w-5 shrink-0 text-[#7b302f]" />
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold" data-testid="small-device-bookstore-title">Welcome to the mobile Bookstore</div>
        <p className="mt-0.5 text-xs leading-5" data-testid="small-device-bookstore-guidance">The writing studio needs a larger display. Open Crown &amp; Rose on an iPad, larger Android tablet, laptop, or desktop to use the full site.</p>
      </div>
      <button type="button" onClick={() => setVisible(false)} className="grid h-8 w-8 shrink-0 place-items-center rounded-sm hover:bg-black/5" aria-label="Dismiss device guidance" data-testid="small-device-bookstore-dismiss"><X className="h-4 w-4" /></button>
    </aside>
  );
};